import apiCall from "./apiCall";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async create_fuel_Tanks(data) {
    let response = await apiCall("fuel_tanks/create", data);
    return response;
  },
  async list_fuel_tanks(data) {
    let response = await apiCall("fuel_tanks/list_fuel_tanks", data);
    return response;
  },
  async update_fuel_Tanks(data) {
    let response = await apiCall("fuel_tanks/update_fuel_tank", data);
    return response;
  },
};
